import { apiClient } from './client'

export interface Role {
  id: string
  name: string
  description: string
  memberCount: number
  isActive: boolean
  createdAt: string
  updatedAt?: string
}

export interface CreateRoleRequest {
  name: string
  description: string
}

export interface UpdateRoleRequest {
  name?: string
  description?: string
  isActive?: boolean
}

// Get all available roles
export const getRoles = async (): Promise<{ data: Role[] }> => {
  const response = await apiClient.get('/roles')
  return response.data
}

// Create new role (Super Admin only)
export const createRole = async (roleData: CreateRoleRequest): Promise<{ data: Role }> => {
  const response = await apiClient.post('/roles', roleData)
  return response.data
}

// Update role (Super Admin only)
export const updateRole = async (roleId: string, roleData: UpdateRoleRequest): Promise<{ data: Role }> => {
  const response = await apiClient.put(`/roles/${roleId}`, roleData)
  return response.data
}

// Delete role (Super Admin only)
export const deleteRole = async (roleId: string): Promise<{ data: Role }> => {
  const response = await apiClient.delete(`/roles/${roleId}`)
  return response.data
}